module.exports = __webpack_public_path__ + "static/media/ASSORTING.57f1f48d.png";